import React from 'react';
import { Breadcrumbs as MuiBreadcrumbs, Typography } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

const routeLabels = {
  'jewelry': 'Jewelry',
  'rings': 'Rings',
  'necklaces': 'Necklaces',
  'earrings': 'Earrings',
  'bracelets': 'Bracelets',
  'piercings': 'Piercings',
  'collections': 'Collections',
  'high-jewelry': 'High Jewelry',
  'watches': 'Watches',
  'services': 'Services',
  'affiliate': 'Affiliate Program',
  'profile': 'Profile',
  'checkout': 'Checkout',
  'login': 'Login',
  'register': 'Register',
};

const Breadcrumbs = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter(x => x);
  const search = new URLSearchParams(location.search);
  const gender = search.get('gender');

  const getLabel = (pathname) => {
    return routeLabels[pathname] || pathname.charAt(0).toUpperCase() + pathname.slice(1);
  };

  return (
    <MuiBreadcrumbs 
      separator={<NavigateNextIcon fontSize="small" />}
      sx={{ 
        mb: 4,
        '& .MuiBreadcrumbs-separator': { color: '#666' },
        '& .MuiBreadcrumbs-li': { color: '#666' },
      }}
    >
      <Link to="/" style={{ color: '#666', textDecoration: 'none' }}>
        Home
      </Link>
      {pathnames.map((value, index) => {
        const to = `/${pathnames.slice(0, index + 1).join('/')}`;
        const isLast = index === pathnames.length - 1;

        if (isLast) {
          let label = getLabel(value);
          if (value === 'collections' && gender) {
            label = `${gender.charAt(0).toUpperCase() + gender.slice(1)}'s Collection`;
          }
          return <Typography key={to} color="textPrimary">{label}</Typography>;
        }

        return (
          <Link
            key={to}
            to={to}
            style={{ color: '#666', textDecoration: 'none' }}
          >
            {getLabel(value)}
          </Link>
        );
      })}
    </MuiBreadcrumbs>
  );
};

export default Breadcrumbs;
